import { NgModule } from '@angular/core';
import { FiltrosInformacionTareasComponent } from './filtros-informacion-tareas.component';

@NgModule({
  imports: [FiltrosInformacionTareasComponent],
  exports: [FiltrosInformacionTareasComponent]
})
export class FiltrosInformacionTareasBridgeModule {}